import Vue from 'vue'
import VueRouter from 'vue-router'
import 'nprogress/nprogress.css'
import NProgress from 'nprogress'

Vue.use(VueRouter)

const user = window.User ? window.User.role.permission : {}

const router = new VueRouter({
  mode: 'history',
  linkExactActiveClass: 'is-active',
  routes: [
    {
      path: '/dashboard',
      name: 'dashboard',
      component: () => import(/* webpackChunkName: "dashboard" */ './views/Index.vue'),
      children: [
        {
          // projects
          path: 'projects',
          name: 'dashboard.projects',
          component: () => import(/* webpackChunkName: "projects" */ './views/Projects/Index.vue'),
          beforeEnter: (to, from, next) => {
            user.projects ? next() : router.go(-1)
          },
          children: [
            {
              // expenses
              path: 'expenses/:id',
              name: 'dashboard.projects.expenses',
              component: () => import(/* webpackChunkName: "projects" */ './views/Projects/Expenses/Index.vue'),
              beforeEnter: (to, from, next) => {
                const projectId = parseInt(to.params.id)
                window.axios.post('/api/v1/projects/user', { id: window.User.id })
                .then(res => {
                  const result = res.data.data.filter(data => data.id === projectId)
                  result.length > 0 ? next() : router.go(-1)
                })
                .catch(error => Promise.reject(error))
                user.expenses ? next() : router.go(-1)
              },
              children: [
                {
                  // reports
                  path: 'reports/:report_id',
                  name: 'dashboard.projects.expenses.reports',
                  component: () => import(/* webpackChunkName: "projects" */ './views/Projects/Expenses/Reports/Index.vue'),
                  beforeEnter: (to, from, next) => {
                    const projectId = parseInt(to.params.id)
                    window.axios.post('/api/v1/projects/user', { id: window.User.id })
                    .then(res => {
                      const result = res.data.data.filter(data => data.id === projectId)
                      result.length > 0 ? next() : router.go(-1)
                    })
                    .catch(error => Promise.reject(error))
                  },
                  children: [
                    {
                      // bulk invoices
                      path: 'bulk',
                      name: 'dashboard.projects.expenses.reports.bulk',
                      component: () => import(/* webpackChunkName: "projects" */ './views/Projects/Expenses/Reports/BulkInvoices/Index.vue'),
                      beforeEnter: (to, from, next) => {
                        const projectId = parseInt(to.params.id)
                        window.axios.post('/api/v1/projects/user', { id: window.User.id })
                        .then(res => {
                          const result = res.data.data.filter(data => data.id === projectId)
                          result.length > 0 ? next() : router.go(-1)
                        })
                        .catch(error => Promise.reject(error))
                      }
                    },
                    {
                      path: '*',
                      component: () => import(/* webpackChunkName: "error" */ './views/Error/PageNotFound.vue'),
                    }
                  ]
                },
                {
                  path: '*',
                  component: () => import(/* webpackChunkName: "error" */ './views/Error/PageNotFound.vue'),
                }
              ]
            },
            {
              // cost codes
              path: 'cost-codes/:id',
              name: 'dashboard.projects.cost-codes',
              component: () => import(/* webpackChunkName: "projects" */ './views/Projects/CostCodes/Index.vue'),
              beforeEnter: (to, from, next) => {
                const projectId = parseInt(to.params.id)
                window.axios.post('/api/v1/projects/user', { id: window.User.id })
                .then(res => {
                  const result = res.data.data.filter(data => data.id === projectId)
                  result.length > 0 ? next() : router.go(-1)
                })
                .catch(error => Promise.reject(error))
                user.cost_codes ? next() : router.go(-1)
              }
            },
            {
              // attendances
              path: 'attendances/:id',
              name: 'dashboard.projects.attendances',
              component: () => import(/* webpackChunkName: "projects" */ './views/Projects/Attendances/Index.vue'),
              beforeEnter: (to, from, next) => {
                const projectId = parseInt(to.params.id)
                window.axios.post('/api/v1/projects/user', { id: window.User.id })
                .then(res => {
                  const result = res.data.data.filter(data => data.id === projectId)
                  result.length > 0 ? next() : router.go(-1)
                })
                .catch(error => Promise.reject(error))
                user.attendances ? next() : router.go(-1)
              },
              children: [
                {
                  // labour
                  path: 'labour/:report_id',
                  name: 'dashboard.projects.attendances.labour',
                  component: () => import(/* webpackChunkName: "projects" */ './views/Projects/Attendances/Labour/Index.vue'),
                  beforeEnter: (to, from, next) => {
                    const projectId = parseInt(to.params.id)
                    window.axios.post('/api/v1/projects/user', { id: window.User.id })
                    .then(res => {
                      const result = res.data.data.filter(data => data.id === projectId)
                      result.length > 0 ? next() : router.go(-1)
                    })
                    .catch(error => Promise.reject(error))
                    user.attendances ? next() : router.go(-1)
                  },
                },
                {
                  // assigned employees
                  path: 'employees',
                  name: 'dashboard.projects.attendances.employees',
                  component: () => import(/* webpackChunkName: "projects" */ './views/Projects/Attendances/Employees/Index.vue'),
                  beforeEnter: (to, from, next) => {
                    const projectId = parseInt(to.params.id)
                    window.axios.post('/api/v1/projects/user', { id: window.User.id })
                    .then(res => {
                      const result = res.data.data.filter(data => data.id === projectId)
                      result.length > 0 ? next() : router.go(-1)
                    })
                    .catch(error => Promise.reject(error))
                    user.attendances ? next() : router.go(-1)
                  },
                },
                {
                  // staff
                  path: 'staff/:report_id',
                  name: 'dashboard.projects.attendances.staff',
                  component: () => import(/* webpackChunkName: "projects" */ './views/Projects/Attendances/Staff/Index.vue'),
                  beforeEnter: (to, from, next) => {
                    const projectId = parseInt(to.params.id)
                    window.axios.post('/api/v1/projects/user', { id: window.User.id })
                    .then(res => {
                      const result = res.data.data.filter(data => data.id === projectId)
                      result.length > 0 ? next() : router.go(-1)
                    })
                    .catch(error => Promise.reject(error))
                    user.attendances ? next() : router.go(-1)
                  },
                }
              ]
            },
            {
              path: '*',
              component: () => import(/* webpackChunkName: "error" */ './views/Error/PageNotFound.vue'),
            }
          ]
        },
        {
          // suppliers
          path: 'suppliers',
          name: 'dashboard.suppliers',
          component: () => import(/* webpackChunkName: "suppliers" */ './views/Suppliers/Index.vue'),
          beforeEnter: (to, from, next) => {
            user.suppliers ? next() : router.go(-1)
          }
        },
        {
          // employees
          path: 'employees',
          name: 'dashboard.employees',
          component: () => import(/* webpackChunkName: "employees" */ './views/Employees/Index.vue'),
          beforeEnter: (to, from, next) => {
            user.employees ? next() : router.go(-1)
          }
        },
        {
          // users
          path: 'users',
          name: 'dashboard.users',
          component: () => import(/* webpackChunkName: "users" */ './views/Users/Index.vue'),
          beforeEnter: (to, from, next) => {
            user.users ? next() : router.go(-1)
          }
        },
        {
          // settings
          path: 'settings',
          name: 'dashboard.settings',
          component: () => import(/* webpackChunkName: "settings" */ './views/Settings/Index.vue'),
          beforeEnter: (to, from, next) => {
            user.settings ? next() : router.go(-1)
          }
        },
        {
          // summary cost codes
          path: 'summary/cost-codes',
          name: 'dashboard.summary.cost_codes',
          component: () => import(/* webpackChunkName: "summary" */ './views/Summary/CostCodes.vue'),
          beforeEnter: (to, from, next) => {
            user.cost_codes ? next() : router.go(-1)
          }
        },
        {
          // summary invoices
          path: 'summary/invoices',
          name: 'dashboard.summary.invoices',
          component: () => import(/* webpackChunkName: "summary" */ './views/Summary/Invoices.vue'),
          beforeEnter: (to, from, next) => {
            user.expenses ? next() : router.go(-1)
          }
        },
        {
          // summary expenses
          path: 'summary/expenses',
          name: 'dashboard.summary.expenses',
          component: () => import(/* webpackChunkName: "summary" */ './views/Summary/Expenses/Index.vue'),
          beforeEnter: (to, from, next) => {
            user.expenses ? next() : router.go(-1)
          },
          children: [
            {
              // pending
              path: 'pending',
              name: 'dashboard.summary.expenses.pending',
              component: () => import(/* webpackChunkName: "summary" */ './views/Summary/Expenses/Pending.vue'),
              beforeEnter: (to, from, next) => {
                user.expenses ? next() : router.go(-1)
              },
            },
            {
              // approved
              path: 'approved',
              name: 'dashboard.summary.expenses.approved',
              component: () => import(/* webpackChunkName: "summary" */ './views/Summary/Expenses/Approved.vue'),
              beforeEnter: (to, from, next) => {
                user.expenses ? next() : router.go(-1)
              },
            },
            {
              path: '*',
              component: () => import(/* webpackChunkName: "error" */ './views/Error/PageNotFound.vue'),
            }
          ]
        },
        {
          // summary attendances
          path: 'summary/attendances',
          name: 'dashboard.summary.attendances',
          component: () => import(/* webpackChunkName: "summary" */ './views/Summary/Attendances/Index.vue'),
          beforeEnter: (to, from, next) => {
            user.attendances ? next() : router.go(-1)
          },
          children: [
            {
              // labour
              path: 'labour',
              name: 'dashboard.summary.labour',
              component: () => import(/* webpackChunkName: "summary" */ './views/Summary/Attendances/Labour/Index.vue'),
              beforeEnter: (to, from, next) => {
                user.attendances ? next() : router.go(-1)
              },
              children: [
                {
                  // attendance accepted
                  path: 'approved',
                  name: 'dashboard.summary.attendance.approved',
                  component: () => import(/* webpackChunkName: "summary" */ './views/Summary/Attendances/Approved.vue'),
                  beforeEnter: (to, from, next) => {
                    user.attendances ? next() : router.go(-1)
                  },
                },
                {
                  // pending
                  path: 'pending',
                  name: 'dashboard.summary.attendance.pending',
                  component: () => import(/* webpackChunkName: "summary" */ './views/Summary/Attendances/Pending.vue'),
                  beforeEnter: (to, from, next) => {
                    user.attendances ? next() : router.go(-1)
                  },
                },
                {
                  path: '*',
                  component: () => import(/* webpackChunkName: "error" */ './views/Error/PageNotFound.vue'),
                }
              ]
            },
            {
              path: '*',
              component: () => import(/* webpackChunkName: "error" */ './views/Error/PageNotFound.vue'),
            }
          ]
        },
        {
          path: 'reporting',
          name: 'reporting',
          component: () => import(/* webpackChunkName: "reporting" */ './views/Reporting/Index.vue'),
        },
        {
          path: '*',
          component: () => import(/* webpackChunkName: "error" */ './views/Error/PageNotFound.vue'),
        }
      ]
    },
    {
      path: '*',
      component: () => import(/* webpackChunkName: "error" */ './views/Error/PageNotFound.vue'),
    }
  ]
})

// before resolve render
router.beforeResolve((to, from, next) => {
  if (to.name) {
    NProgress.configure({ showSpinner: false })
    NProgress.start()
  }
  next()
})

// after each render
router.afterEach(() => {
  NProgress.done()
})

// export router
export default router
